<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			item-key="id"
			hide-default-footer
			:server-items-length="totalItens"
			:options="paginacaoInterna"
			class="arp-listview row-pointer"
		>
			<template #item.responsavel="{ item }">
				<texto-tooltip :texto="item.autor" :tamanho-maximo="textoTamanhoMaximo.responsavel"></texto-tooltip>
			</template>
			<template #item.ultimaAtualizacao="{ item }">
				<span> {{ item.dataAlteracao | formatDataHourMinuteFilter }} </span>
			</template>
			<template #item.atividade="{ item }">
				<texto-tooltip :texto="item.atividade" :tamanho-maximo="textoTamanhoMaximo.atividade"></texto-tooltip>
			</template>
			<template #item.descricao="{ item }">
				<span v-if="item.descricao.length < textoTamanhoMaximo.descricao"> {{ item.descricao }} </span>
				<span v-else>
					{{ tratarTextoDescricao(item.descricao) }}
					<button
						@click="abrirOrFecharModalDescricaoOcorrencia(item)"
						class="btn btn-primary blue--text text-decoration-underline"
					>
						ver mais
					</button>
				</span>
			</template>
			<template #item.respostas="{ item }">
				<texto-tooltip :texto="item.quantidadeRespostas.toString()"></texto-tooltip>
			</template>
			<template #item.acoes="{ item }">
				<listagem-ocorrencia-acoes
					@responder="abriOrFecharModalResponderOcorrencia"
					@visualizar="tratarEventoVisualizarOcorrencia"
					@editar="abrirOrFecharModalEditarOcorrencia"
					@excluir="excluirOcorrencia"
					:item="item"
					:has-authority="hasAuthority"
				></listagem-ocorrencia-acoes>
			</template>
		</v-data-table>
		<template-listagem-vazia :total-itens="totalItens" :textos="textoListagemVazia">
			<template #acoes>
				<botao-primario
					v-az-auth="permissoes.ataOcorrenciaEditar"
					v-if="hasAuthority"
					nome-botao="ADICIONAR"
					icone="add_circle"
					class="botao-tamanho-arp mr-2"
					@click="$emit('inserir')"
				></botao-primario>
			</template>
		</template-listagem-vazia>
		<paginacao-tabela
			v-if="totalItens > 0"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>

		<modal-descricao-ocorrencia
			v-if="exibirModalDescricaoOcorrencia"
			:exibir="exibirModalDescricaoOcorrencia"
			titulo-modal="Descrição"
			@fechar-modal="abrirOrFecharModalDescricaoOcorrencia"
			:descricao="ocorrenciaSelecionada.descricao"
		>
		</modal-descricao-ocorrencia>

		<modal-resposta-ocorrencia
			v-if="exibirModalRespostaOcorrencia"
			:exibir="exibirModalRespostaOcorrencia"
			titulo-modal="Responder Ocorrência"
			@fechar-modal="abriOrFecharModalResponderOcorrencia"
			:ocorrencia-info="ocorrenciaSelecionada"
			@confirmar="enviarResposta"
		>
		</modal-resposta-ocorrencia>

		<modal-visualizar-ocorrencia
			v-if="modalVisualizarOcorrencia.exibir"
			titulo="Visualizar Ocorrência"
			:exibir="modalVisualizarOcorrencia.exibir"
			:ocorrencia="ocorrenciaSelecionada"
			@editar-resposta="tratarEventoEditarResposta"
			@fechar-modal="abrirOrFecharModalVisualizarOcorrencia"
			:has-authority="hasAuthority"
		></modal-visualizar-ocorrencia>

		<modal-editar-resposta-ocorrencia
			v-if="modalEditarRespostaOcorrencia.exibir"
			titulo="Editar Resposta"
			:exibir="modalEditarRespostaOcorrencia.exibir"
			:ocorrencia="ocorrenciaSelecionada"
			:resposta="respostaSelecionada"
			@editar-resposta="editarResposta"
			@fechar-modal="abrirOrFecharModalEditarRespostaOcorrencia"
		></modal-editar-resposta-ocorrencia>

		<modal-editar-ocorrencia
			v-if="exibirModalEditarOcorrencia"
			:exibir="exibirModalEditarOcorrencia"
			titulo-modal="Editar Ocorrência"
			@fechar-modal="abrirOrFecharModalEditarOcorrencia"
			:ocorrencia-info="ocorrenciaSelecionada"
			@confirmar="enviarEdicaoOcorrencia"
		>
		</modal-editar-ocorrencia>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import ListagemOcorrenciaAcoes from '@/views/components/ocorrencia/listagem/acoes/ListagemOcorrenciaBotoesAcoes.vue'
import modalDescricaoOcorrencia from '@/views/components/ocorrencia/modal-decricao/ModalDescricaoOcorrencia.vue'
import modalVisualizarOcorrencia from '@/views/components/ocorrencia/modal-visualizar-ocorrencia/ModalVisualizarOcorrencia.vue'
import tabela from '@/views/mixins/tabela'
import validacaoAta from '@/views/mixins/validacaoAta'
import PaginacaoTabela from '@/views/components/PaginacaoTabela.vue'
import TemplateListagemVazia from '@/views/components/TemplateListagemVazia.vue'
import ModalRespostaOcorrencia from '@/views/components/ocorrencia/modal-resposta/ModalRespostaOcorrencia.vue'
import { actionTypes, permissoes } from '@/core/constants'
import ModalEditarRespostaOcorrencia from '@/views/components/ocorrencia/modal-resposta/ModalEditarRespostaOcorrencia.vue'
import ModalEditarOcorrencia from '@/views/components/ocorrencia/modal-editar/ModalEditarOcorrencia.vue'
import BotaoPrimario from '@/views/components/BotaoPrimario.vue'
import permissoesMixin from '@/views/mixins/permissoes-mixin'

export default {
	name: 'listar-ocorrencia',
	components: {
		BotaoPrimario,
		ModalEditarOcorrencia,
		ModalEditarRespostaOcorrencia,
		TemplateListagemVazia,
		PaginacaoTabela,
		modalDescricaoOcorrencia,
		ModalRespostaOcorrencia,
		modalVisualizarOcorrencia,
		ListagemOcorrenciaAcoes,
	},
	mixins: [tabela, validacaoAta, permissoesMixin],
	props: {
		itens: {
			type: Array,
			default: () => [],
		},
		totalItens: {
			type: Number,
			default: 0,
		},
		idEntidade: {
			type: [String, Number],
			required: true,
		},
		tipoEntidade: {
			type: String,
			required: true,
		},
		hasAuthority: {
			type: Boolean,
		},
	},
	data() {
		return {
			paginacaoInterna: this.paginacao,
			colunas: [
				new TabelaColunaUtils('Responsável', 'responsavel', '20%'),
				new TabelaColunaUtils('Última Atualização', 'ultimaAtualizacao', '10%'),
				new TabelaColunaUtils('Atividade', 'atividade', '15%'),
				new TabelaColunaUtils('Descrição', 'descricao', '30%'),
				new TabelaColunaUtils('Respostas', 'respostas', '15%', 'center'),
				new TabelaColunaUtils('Ações', 'acoes', '15%', 'center'),
			],
			textoTamanhoMaximo: {
				responsavel: 30,
				ultimaAtualizacao: 25,
				atividade: 25,
				descricao: 40,
				respostas: 10,
			},
			exibirModalDescricaoOcorrencia: false,
			exibirModalRespostaOcorrencia: false,
			exibirModalEditarOcorrencia: false,
			ocorrenciaSelecionada: null,
			respostaSelecionada: null,
			modalVisualizarOcorrencia: {
				exibir: false,
			},
			modalEditarRespostaOcorrencia: {
				exibir: false,
			},
			ocorrencia: {
				id: null,
				descricao: null,
			},
			resposta: {
				id: null,
				descricao: null,
			},
		}
	},
	computed: {
		hasItens() {
			return this.totalItens > 0
		},
		textoListagemVazia() {
			const textos = { titulo: 'Não foram encontradas ocorrências.' }

			if (this.verificarPermissao(permissoes.ataOcorrenciaEditar) && this.hasAuthority) {
				textos['mensagem'] = 'Clique no botão para adicionar'
			}

			return textos
		},
	},
	async created() {},
	methods: {
		async resetarPage() {
			this.$emit('resetar-page')
		},
		fecharModalEditarRespostaOcorrencia() {
			this.exibirModal = false
			this.modalEditarRespostaOcorrencia.exibir = false
			this.resposta = { id: null, descricao: null }
			this.ocorrencia = { id: null, descricao: null }
		},
		excluirOcorrencia(id) {
			this.$emit('excluir', id)
		},
		tratarTextoDescricao(descricao) {
			return descricao.substring(0, this.textoTamanhoMaximo.descricao).concat('...')
		},
		abrirOrFecharModalDescricaoOcorrencia(item) {
			this.ocorrenciaSelecionada = item
			this.exibirModalDescricaoOcorrencia = !this.exibirModalDescricaoOcorrencia
		},
		abriOrFecharModalResponderOcorrencia(item) {
			this.ocorrenciaSelecionada = item
			this.exibirModalRespostaOcorrencia = !this.exibirModalRespostaOcorrencia
		},
		abrirOrFecharModalVisualizarOcorrencia(item) {
			this.modalVisualizarOcorrencia.exibir = !this.modalVisualizarOcorrencia.exibir
			this.ocorrenciaSelecionada = item
		},
		abrirOrFecharModalEditarRespostaOcorrencia(item) {
			this.ocorrenciaSelecionada = item
			this.modalEditarRespostaOcorrencia.exibir = !this.modalEditarRespostaOcorrencia.exibir
		},
		async enviarResposta(infoResposta) {
			await this.$store.dispatch(actionTypes.OCORRENCIA.ENVIAR_RESPOSTA_OCORRENCIA, {
				...infoResposta,
				entidadeTipo: this.tipoEntidade,
				idEntidade: this.idEntidade,
			})
			this.$emit('carregar-listagem')
			this.mostrarNotificacaoSucessoDefault()
			this.abriOrFecharModalResponderOcorrencia(null)
		},
		async tratarEventoEditarResposta({ ocorrencia, resposta }) {
			this.abrirOrFecharModalVisualizarOcorrencia()
			this.respostaSelecionada = resposta
			this.abrirOrFecharModalEditarRespostaOcorrencia(ocorrencia)
		},
		async tratarEventoVisualizarOcorrencia(ocorrencia) {
			const payload = {
				idOcorrencia: ocorrencia.id,
				entidadeTipo: this.tipoEntidade,
				idEntidade: Number(this.idEntidade),
			}

			this.ocorrencia = await this.$store.dispatch(actionTypes.OCORRENCIA.VISUALIZAR_OCORRENCIA, payload)
			this.ocorrenciaSelecionada = this.ocorrencia
			this.modalVisualizarOcorrencia.exibir = true
		},
		async editarResposta(payload) {
			const payloadEdicao = {
				idResposta: payload.idResposta,
				entidadeTipo: this.tipoEntidade,
				idEntidade: Number(this.idEntidade),
				resposta: payload.resposta,
			}
			await this.$store.dispatch(actionTypes.OCORRENCIA.EDITAR_RESPOSTA, payloadEdicao)
			this.fecharModalEditarRespostaOcorrencia()
			this.mostrarNotificacaoSucesso('Resposta editada com sucesso!')
		},
		abrirOrFecharModalEditarOcorrencia(item) {
			this.exibirModalEditarOcorrencia = !this.exibirModalEditarOcorrencia
			this.ocorrenciaSelecionada = item
		},
		async enviarEdicaoOcorrencia(item) {
			await this.$store.dispatch(actionTypes.OCORRENCIA.EDITAR_OCORRENCIA, {
				...item,
				entidadeTipo: this.tipoEntidade,
				idEntidade: this.idEntidade,
			})
			this.$emit('carregar-listagem')
			this.mostrarNotificacaoSucesso('Edição realizada com sucesso!')
			this.abrirOrFecharModalEditarOcorrencia(null)
		},
	},
}
</script>
<style lang="stylus" scoped></style>
